import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=48f5d5f2&"
import script from "./dataForm.vue?vue&type=script&lang=js&"
export * from "./dataForm.vue?vue&type=script&lang=js&"
import style0 from "./dataForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports